/* eslint-disable */
export default [
  {
      name: 'youtube',
      regex: /(youtube|youtu.be)/i,
      id: 'YouTube Video',
  },
  {
      name: 'google_maps',
      regex: /(maps\/embed|maps\\embed)/i,
      id: 'Google Maps',
  },
];
